// extracted by mini-css-extract-plugin
module.exports = {"specItem":"styles__specItem--nr5GJ","specLabel":"styles__specLabel--24yTC","specValue":"styles__specValue--nJ1Tb","icon":"styles__icon--30oKA"};